var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getCookie } from '.';
/**
 * Operations we want to apply for all analytics events should be added as middleware
 * to allow a standard `window.analytics.track` call to handle custom logic such as adding
 * additional ids, enhancing events with special properties, filtering out sensitive data, etc
 * */
export var withTiktokPixelCookies = function (_a) {
    var payload = _a.payload, next = _a.next;
    var type = payload.type();
    var ttpCookie = getCookie('_ttp');
    var ttclidCookie = getCookie('ttclid');
    if (type === 'track' || type === 'page') {
        payload.obj.properties = __assign(__assign(__assign({}, payload.obj.properties), (ttpCookie && { ttp: ttpCookie })), (ttclidCookie && { ttclid: ttclidCookie }));
    }
    next(payload);
};
export var withConciousPartnerCookies = function (_a) {
    var payload = _a.payload, next = _a.next;
    var type = payload.type();
    var cpclidCookie = getCookie('cpclid');
    if (type === 'track' || type === 'page') {
        payload.obj.properties = __assign(__assign({}, payload.obj.properties), (cpclidCookie && { cpclid: cpclidCookie }));
    }
    next(payload);
};
// This fixes a bug in Segment Amplitude integration.
// https://jouzen.atlassian.net/browse/MMBER-4110
export var withAmplitudeActionsFix = function (_a) {
    var payload = _a.payload, next = _a.next;
    var integrations = payload.obj.integrations;
    if (integrations) {
        var amplitudeEnabled = Boolean(integrations['Actions Amplitude']);
        if (amplitudeEnabled) {
            integrations['Amplitude (Actions)'] = true;
        }
    }
    next(payload);
};
// Order matters here
export var middlewares = [
    withTiktokPixelCookies,
    withConciousPartnerCookies,
    withAmplitudeActionsFix,
];
export function applyMiddleware() {
    var _a;
    middlewares.forEach((_a = window.analytics) === null || _a === void 0 ? void 0 : _a.addSourceMiddleware);
}
//# sourceMappingURL=data:application/json;base64,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